// 123back-frontend/src/i18n/components/common/FancyToast.js
// Ce module est enregistré via register('fancyToast', ...)
// DONC on ne répète PAS "fancyToast" à l'intérieur des clés.
export default {
  fr: {
    a11y: {
      close: 'Fermer',
    },
    default: {
      successTitle: 'Succès',
      celebrationTitle: 'Bienvenue !',
      subtitle: 'Opération effectuée avec succès.',
    },
    login: {
      title: 'Connecté(e) !',
      subtitle: 'Heureux de vous revoir 👋',
    },
    register: {
      title: 'Bienvenue !',
      subtitle: 'Votre compte a été créé et vous êtes connecté.',
    },
  },

  en: {
    a11y: {
      close: 'Close',
    },
    default: {
      successTitle: 'Success',
      celebrationTitle: 'Welcome!',
      subtitle: 'Operation completed successfully.',
    },
    login: {
      title: 'Signed in!',
      subtitle: 'Great to see you again 👋',
    },
    register: {
      title: 'Welcome!',
      subtitle: "Your account is created and you're signed in.",
    },
  },

  pl: {
    a11y: {
      close: 'Zamknij',
    },
    default: {
      successTitle: 'Sukces',
      celebrationTitle: 'Witamy!',
      subtitle: 'Operacja zakończona powodzeniem.',
    },
    login: {
      title: 'Zalogowano!',
      subtitle: 'Miło Cię znów widzieć 👋',
    },
    register: {
      title: 'Witamy!',
      subtitle: 'Twoje konto zostało utworzone i zalogowano Cię.',
    },
  },
  es: {
    a11y: {
      close: 'Cerrar',
    },
    default: {
      successTitle: 'Éxito',
      celebrationTitle: '¡Bienvenido!',
      subtitle: 'Operación realizada con éxito.',
    },
    login: {
      title: '¡Conectado!',
      subtitle: 'Nos alegra verte de nuevo 👋',
    },
    register: {
      title: '¡Bienvenido!',
      subtitle: 'Tu cuenta ha sido creada y ya estás conectado.',
    },
  },
  pt: {
    a11y: {
      close: 'Fechar',
    },
    default: {
      successTitle: 'Sucesso',
      celebrationTitle: 'Bem-vindo!',
      subtitle: 'Operação concluída com sucesso.',
    },
    login: {
      title: 'Sessão iniciada!',
      subtitle: 'É bom voltar a vê-lo 👋',
    },
    register: {
      title: 'Bem-vindo!',
      subtitle: 'A sua conta foi criada e a sessão está iniciada.',
    },
  },
};
